module.exports = __webpack_public_path__ + "static/media/superscript.e3b2a338.svg";